import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import './estilos.css';
import { App } from './app.tsx';

const raiz = document.getElementById('raiz');
if (!raiz) throw new Error('Falta #raiz en index.html.');

// El tema se aplica antes del primer render para que no haya un destello claro al abrir la app
// en un gimnasio a oscuras.
try {
  const tema = localStorage.getItem('mg.tema');
  if (tema === 'claro') document.documentElement.dataset['tema'] = 'claro';
} catch {
  // Sin localStorage se queda con el tema oscuro, que es el default.
}

createRoot(raiz).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
